// Âge de la dernière nouvelle d'une fiche : au-delà de 12 mois sans source nouvelle, le projet a pu être abandonné,
// achevé ou changé de nom ; la fiche le signale pour qu'on le vérifie avant de prospecter.
export const STALE_NEWS_MONTHS = 12;

export const isStaleNews = (
  date: string | null | undefined,
  now: Date = new Date(),
) => {
  if (!date) return false;
  const limit = new Date(now);
  limit.setUTCMonth(limit.getUTCMonth() - STALE_NEWS_MONTHS);
  return new Date(date) < limit;
};

type DatedSource = {
  source_id: string;
  published_at?: string | null;
  collected_at: string;
};

/** Date d'une source : sa publication, sinon sa collecte. Pour la Banque mondiale, la date publiée est celle de
 * l'approbation, parfois future : on garde la collecte (même règle que la vue projects_summary). */
export const newsDate = (source: DatedSource) =>
  source.source_id === "worldbank" || !source.published_at
    ? source.collected_at
    : source.published_at;
